import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ShowForPermission from '../../../components/ShowForPermission';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import ReserveRequestsListFilter from './ListFilter';
import ReserveRequestsListTable from './ListTable';
import ReserveDetailsModal from '../modals/ReserveDetails';
import * as reservationActions from '../../../redux/reservations/actions';
import enums from '../../../enums';
import submitForm from '../../../utils/submitForm';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class ReserveRequests extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      itemsPerPage: 10,
      sortType: 'asc',
      sortBy: 'createdAt',
      query: '',
      reserveDetailsModalIsOpen: false,
      selectedReserveId: null,
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.updateSocketReserve !== this.props.updateSocketReserve ||
      prevState.currentPage !== this.state.currentPage ||
      prevState.query !== this.state.query
    ) {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.getAll(query);
    }
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage });
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;

    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }

    this.setState({ query, currentPage: 1 });
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  displayReserveDetailsModal = id => {
    console.log(id);
    const selectedReserve = this.props.reservationRequestsList.filter(
      x => x.id == id,
    );

    if (selectedReserve) {
      this.setState(() => ({
        reserveDetailsModalIsOpen: true,
        selectedReserveId: id,
      }));
    }
  };

  closeReserveDetailsModal = (success = true) => {
    if (success) {
      // refresh list and close modal
      this.setState({
        currentPage: 1,
        reserveDetailsModalIsOpen: false,
        selectedReserveId: null,
      });
    } else {
      // close modal
      this.setState(() => ({
        reserveDetailsModalIsOpen: false,
        selectedReserveId: null,
      }));
    }
  };

  render() {
    const {
      loading,
      message,
      failed,
      error,
      totalRecords,
      reservationRequestsList,
    } = this.props;
    const { currentPage, itemsPerPage, sortType } = this.state;

    return (
      <Spin spinning={loading}>
        {this.state.errorFlag && this.handleAlert()}
        <div className='col-12 d-flex justify-content-between align-items-center'>
          <h3 className='text-right text-muted py-4'>
            <div className='text-right'>
              {locales('titles.reservationRequests')}
            </div>
          </h3>
        </div>
        <section className='p-1 col-12'>
          <article>
            <main className='panel panel-default'>
              {error ? (
                <div className='alert alert-danger'>
                  {locales('messages.server.error')}
                </div>
              ) : (
                <>
                  {failed && (
                    <div className='alert alert-danger'>{message}</div>
                  )}
                  <ShowForPermission
                    permission={
                      enums.PERMISSIONS.values.VIEW_REQUESTS_RESERVES_FOR_ADMIN
                    }
                  >
                    <ReserveRequestsListFilter
                      applyFilters={this.applyFilters}
                      filterAndSort={this.filterAndSort}
                    />
                  </ShowForPermission>
                  <div className='panel-heading'>
                    <i className='fas fa-list-alt px-1' />
                    {locales('titles.reservationRequestsList')}
                  </div>
                  <div className='panel-body'>
                    <ReserveRequestsListTable
                      reservationRequestsList={reservationRequestsList}
                      totalRecords={totalRecords}
                      pageNumber={currentPage}
                      pageSize={itemsPerPage}
                      sortType={sortType}
                      sortTable={this.sortTable}
                      displayReserveDetailsModal={
                        this.displayReserveDetailsModal
                      }
                      closeReserveDetailsModal={this.closeReserveDetailsModal}
                    />

                    <div className='pagination-container'>
                      <Pagination2
                        totalRecords={totalRecords}
                        pageLimit={itemsPerPage}
                        pageNeighbours={2}
                        onPageChanged={this.onPageChanged}
                        currentPage={this.state.currentPage}
                      />
                    </div>
                  </div>
                </>
              )}
            </main>
          </article>
        </section>

        {this.state.reserveDetailsModalIsOpen && (
          <ReserveDetailsModal
            reserveId={this.state.selectedReserveId}
            isOpen={this.state.reserveDetailsModalIsOpen}
            close={this.closeReserveDetailsModal}
          />
        )}
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationRequestsList: state.reservationsReducer.reservationRequestsList,
    totalRecords: state.reservationsReducer.reservationRequestsListTotalRecords,
    loading: state.reservationsReducer.reservationRequestsLoading,
    message: state.reservationsReducer.reservationRequestsMessage,
    failed: state.reservationsReducer.reservationRequestsFailed,
    error: state.reservationsReducer.reservationRequestsError,
    updateSocketReserve: state.notificationsReducer.updateSocketReserve,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      getAll: query =>
        dispatch(reservationActions.getReservesRequestsList(query)),
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReserveRequests),
);
